<style lang="less" scoped>
.newsExhibition {position: relative;overflow: hidden;font-family: AlibabaPuHuiTi-Regular;
  ul{list-style:none;margin:0px;padding:0px 10px;}
  li {position: relative;display: block;margin:0px;padding:0px;overflow: hidden;cursor: pointer;}
  li:hover {background: #ffffff;}
  div, p {margin:0px;padding:0px;}
  .titleFirst {font-size: 14px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #333;height: 35px;line-height: 35px;text-align: left;}
  .box {position: absolute;overflow: hidden;height: 0;top: 0;left: 0;transition: height 0.3s;background: rgb(248, 247, 247);}
  .picBox {float: left;width: 100px;height: 68px;overflow: hidden;border: 1px solid #eee;}
  img {border: none;vertical-align: top;width: 100px;height: 68px;transition: transform .5s;}
  img:hover {transform: scale(1.4,1.2)}
  .textBox {float: left;margin-top: -70px;margin-left: 110px;width: 445px;text-align: left;}
  .title {width: 380px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-size: 14px;color: #333;font-weight: 600;}
  .title:hover {color: #13569e;}
  .content {width: 440px;font-size: 12px;color: rgb(73, 73, 73);overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;margin-top: 2px;}
  .content{height: 35px;line-height: 17px; overflow:hidden;}
  .content::after{content: ' ... ';}
  .time{font-size: 12px;margin-top: 0px;}
  li:nth-child(1) {height: 70px;}
  li:nth-child(1) .box {height: 70px;}
  li:hover {height: 70px;}
  li:hover .box {height: 70px;}
}
</style>

<!--何宽 2021.6.12
    该卡片组件使用场景：以列表的形式纵向展示各条新闻的标题，当鼠标移入某条新闻的时候，该新闻展开图片、标题及内容（默认第一条展开）
    鼠标移入新闻的图片上时，图片会放大，
    鼠标点击新闻的图片、标题或内容，将 整个新闻的对象 传递给父组件 -->
<template>
  <div class="newsExhibition">
    <ul>
      <li v-for="(item,index) in newsKYZXList" :key="index" @click="clickNewsExhibition(item)">
        <p class="titleFirst"> {{ item.title }} </p>
        <div class="box">
          <div class="picBox">
            <img :src="item.pic">
          </div>
          <div class="textBox">
            <p class="title"> {{ item.title }} </p>
            <p class="content"> {{ item.content }} </p>
            <p class="time"> {{ item.time * 1000 | formatDate() }} </p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import $ from 'jquery'
import filters from '../method/filter.js'
export default {
  props: ['newsKYZXList'],
  mixins: [filters],
  data()
  {
    return {}
  },
  updated()
  {
    $('.newsExhibition ul li:nth-child(n+2)').mouseenter(function()
    {
      $('.newsExhibition ul li:nth-child(1)').css('height', '35px')
      $('.newsExhibition ul li:nth-child(1) .box').css('height', '0')
    })
    $('.newsExhibition ul li:nth-child(n+2)').mouseleave(function()
    {
      $('.newsExhibition ul li:nth-child(1)').css('height', '70px')
      $('.newsExhibition ul li:nth-child(1) .box').css('height', '70px')
    })
    var oList = document.querySelectorAll('.content')
    var alltableArray = Array.prototype.slice.call(oList)
    alltableArray.forEach(function(item)
    {
      var oHeight = item.height
      if ((oHeight / 15) > 2)
        item.className = 'content'
    })
  },
  methods: {
    // 点击 新闻图片、名称或内容，将 整个新闻对象 传递给父组件
    clickNewsExhibition(item)
    {
      this.$emit('clickNews', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/NewsEXhibition.vue